import { collection, getDocs, query } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { Article, ArticleBrandId, ArticleCategory } from "../types";

export const getArticlesList = async (
  brandId: ArticleBrandId,
  categoryId: ArticleCategory,
): Promise<Article[]> => {
  const articlesRef = collection(
    db,
    `/legalDocuments/${brandId}/${categoryId}`,
  );

  const q = query(articlesRef);
  const articlesSnapshot = await getDocs(q);

  return articlesSnapshot.docs.map((doc) => doc.data()) as Article[];
};
